/*eslint-disable*/
import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { SyncClient } from 'twilio-sync';
import { usePostHog } from 'posthog-js/react';

import {
    Spinner,
} from "reactstrap";
import client from "../../common/api";


import AuthModal from './AuthModal';
import PublicNavbar from './PublicNavbar';
import RoadmapContent from './RoadmapContent.js'; // Newly added import for the extracted component
import WithBillingDetails from '../../common/hoc/WithBillingDetails';
import {
    getCookie,
    generateRandomEmail,
    setPlCookie,
} from '../../common/Utils';

import './roadmap.public.scss';

{
    /*
        Contents of PublicWrapper.js
        > get active space from url.
        > get survey key from url.
        > get company info from survey key.
        > get roadmap details from company id.
        > show roadmap details.
        > get user details from cookie if user is logged in.
        > if user is not logged in then show login modal, if any action is performed.
        > handle social login/signup.
        > handle guest login from cookie.
    */
}

const PublicWrapper = ({
    oldurl,
    billingDetails,
}) => {
    const location = useLocation();
    const match = { params: useParams() };
    const navigate = useNavigate();
    const posthog = usePostHog();
    const activeDomain = window.location.hostname.split('.')[1];
    const [isOpen, setIsOpen] = useState(false);
    const [roadmapLoader, setRoadmapLoader] = useState(true);
    const [isAnonymous, setIsAnonymous] = useState({
        value: false,
        email: '',
        name: '',
        actions: {},
    });
    const [roadmapInfo, setRoadmapInfo] = useState({
        title: '',
        description: '',
        upvotes: 0,
        comments: [],
        created_at: '',
        upvoters: [],
        activity: [],
    });
    const [saveCommentsLoader, setSaveCommentsLoader] = useState({
        show: false,
        text: '',
    });
    const [commentsAlert, setCommentsAlert] = useState({
        show: false,
        text: '',
        type: '',
    });
    const [authPayload, setauthPayload] = useState({
        name: '',
        email: '',
        password: '',
    });
    const [totalRoadmaps, setTotalRoadmaps] = useState(0);
    const [allRoadmaps, setAllRoadmaps] = useState([]);
    const [navOption, setnavOption] = useState({
        parent: match.params?.feature || 'roadmap',
        slug: match.params?.slug,
    });
    const [poweredBy, setPoweredBy] = useState('');
    const [companyInfo, setCompanyInfo] = useState({
        name: '',
        logo: '',
        roadmap_title: '',
        roadmap_description: '',
        feature_request_title: '',
        feature_request_description: '',
        changelog_title: '',
        changelog_subtitle: '',
    });
    const [roadmapModal, setRoadmapModal] = useState({
        show: false,
        roadmap: {},
    });
    const [publicAuthModal, setPublicAuthModal] = useState({
        show: false,
        roadmap: {},
        type: 'login',  // login, signup, overview.
        overviewType: 'login',
        callbackId: '',
        callbackParam: '',
    });
    const [commentsInfo, setcommentsInfo] = useState({
        value: '',
        submittedBy: '',
    });
    const [payloadValid, setPayloadValid] = useState({
        show: false,
        text: '',
        type: ''
    });
    const [publicUserInfo, setPublicUserInfo] = useState({});
    const activeSpace = window.location.host.split('.')[0];

    const getToken = () => {
        const url = `web/notifications/token`;
        client.post(url).then(data => {
            //console.log('twillio data--', data);
            const respData = data['data'];
            const syncClient = new SyncClient(respData.token);

            syncClient.list("ploauth").then((response) => {
                response.on("itemAdded", (e) => {
                    const notifyData = e.item.descriptor?.data;
                    if (notifyData?.type === 'public_user_auth') {
                        handleSocialAuth(notifyData)
                    }
                });
            });
        })
            .catch(error => {
                // handle error
                console.log('twillio error--', error);
            });
    }

    const handleSuccess = (_authResp, refresh) => {
        setTimeout(() => {
            if (refresh) {
                authModalToggle();
                window.location.reload();
            }
        }, 1500);
    };

    const updateCompanyPublicUser = (email) => {
        if (!email) return;
        const hostUrl = window.location.host;
        const _hostUrl = hostUrl.replace("www.", "");
        const _payload = {
            email,
            company: companyID,
            url: _hostUrl,
        }
        client.post(`/api/company/update`, _payload).then(response => {
            console.log('company update response---', response);
        }).catch(error => {
            console.log('company update error---', error);
        });
    }

    // called after google login/signup
    const handleSocialAuth = (authData) => {
        const { success, msg } = authData;
        setPayloadValid({ show: true, text: msg, type: success ? 'primary' : 'warning' });
        if (success) {
            handleSuccess(authData, false);
            updateCompanyPublicUser(authData.email);
            setTimeout(() => {
                setPublicAuthModal({
                    show: false,
                    type: 'overview',
                    overviewType: 'signup',
                });
            }, 1500);
            setTokenExists(parseJwt(authData.access_token));
            setPlCookie('pl.authToken', authData.access_token, 30, activeDomain);
            setPlCookie('pl.refreshToken', authData.refresh_token, 30, activeDomain);
            setPlCookie('pl.authType', authData.authType, 30, activeDomain);
            setPlCookie('pl.authEmail', authData.email, 30, activeDomain);
        } else {
            setPublicAuthModal(prev => ({ ...prev, show: true }));
        }
    };

    const parseJwt = (token) => {
        if (!token) {
            return;
        }
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    };

    const getInitialToken = () => {
        const token = getCookie('pl.authToken') || getCookie('pl.guestToken');
        return token;
    }

    // dont move this.
    const [tokenExists, setTokenExists] = useState(parseJwt(getInitialToken()));

    const roadmapToggle = () => setRoadmapModal({ show: !roadmapModal });

    const authModalToggle = (type, callbackId, callbackParam) => {
        setPublicAuthModal({
            show: !publicAuthModal.show,
            type: 'overview',
            overviewType: type || 'signup',
            callbackId,
            callbackParam,
        });
    };

    const openRoadmapDetailsPage = (roadmap) => {
        setRoadmapInfo({
            title: '',
            description: '',
            upvotes: 0,
            comments: [],
        })
        navigate(`/feature_requests/${roadmap.slug}`);
        getPostsDetails(roadmap.slug);
    };

    const validatePayload = () => {
        let status = true;
        let errorMessage = '';

        if (publicAuthModal.type === 'signup' && authPayload.name === '') {
            errorMessage = 'Please enter your full name';
            status = false;
        } else if (authPayload.email === '') {
            errorMessage = 'Please enter your email';
            status = false;
        } else if (authPayload.password === '') {
            errorMessage = 'Please enter your password';
            status = false;
        }

        if (errorMessage) {
            setPayloadValid({ show: true, type: 'danger', text: errorMessage });
            setTimeout(() => {
                setPayloadValid({ show: false, text: '' });
            }, 3000);
        }
        return status;
    };

    //manual auth submit from public login/signup.
    const submitAuthManual = () => {
        if (!validatePayload()) return;

        const _hostUrl = hostUrl.replace("www.", "");
        const endpoint = `/feedback/public/auth/${publicAuthModal.type}`;
        const payload = {
            ...authPayload,
            company: companyID,
            activeSpaceName: activeSpace,
            url: _hostUrl
        }
        client.post(endpoint, payload).then(response => {
            const { data } = response;
            const messageType = data.success ? 'primary' : 'danger';
            const messageText = data.success ? (publicAuthModal.type === 'signup' ? 'Account created' : 'Success') : data.msg;

            setPayloadValid({ show: true, text: messageText, type: messageType });

            if (data.success) {
                // this just hides the auth modal.
                handleSuccess(data, true);
                setPlCookie('pl.authToken', data.access_token, 30, activeDomain);
                setPlCookie('pl.refreshToken', data.refresh_token, 30, activeDomain);

                // called from public user manual login from UI.
                if (publicAuthModal.type === 'login') {

                    //set cookie 
                    setTimeout(() => {
                        authModalToggle();
                        // window.location.reload();
                    }, 1500);
                }
            }

            setTimeout(() => {
                setPayloadValid({ show: false, text: '' });
            }, 3000);

        }).catch(error => {
            console.error('Authentication error:', error);
            setPayloadValid({ show: true, text: 'An error occurred', type: 'danger' });
        });
    };

    const hostUrl = window.location.host;
    const companyID = window.location.host.split('.')[0];
    const toggle = () => setIsOpen(!isOpen);

    const changeNavOption = (option) => {
        // set all roadmaps to show all the roadmaps.
        setAllRoadmaps(totalRoadmaps);
        navigate(`/${option}`);
        setnavOption({
            parent: option,
            child: '',
        });
    };

    const getUserToken = () => {
        const _tokenExists = parseJwt(getInitialToken());
        if (_tokenExists) {
            setTokenExists(_tokenExists);
            return { email: _tokenExists.sub, is_guest_user: _tokenExists.is_guest_user };
        }
        return undefined;
    };

    const getRoadmapDetails = (companyId) => {
        setRoadmapLoader(true);
        const _hostUrl = hostUrl.replace("www.", "");
        client.get(`/feedback/public/${companyId}`, { params: { activeSpaceName: activeSpace, url: _hostUrl } })
            .then(response => {
                const { data } = response;
                if (data.success) {
                    const { roadmaps, company_info } = data.data;
                    setCompanyInfo(company_info);
                    setTotalRoadmaps(roadmaps);
                    roadmaps.sort((a, b) => new Date(b.updated_at['$date']) - new Date(a.updated_at['$date']));
                    setAllRoadmaps(roadmaps);
                } else {
                    console.log('Roadmap detail error:', data);
                }
            })
            .catch(error => {
                console.error('Error fetching roadmap details:', error);
            })
            .finally(() => {
                setRoadmapLoader(false);
            });
    };

    const filterRoadmaps = (category) => {
        if (category === 'all') {
            setAllRoadmaps(totalRoadmaps);
        } else {
            const filteredRoadmaps = totalRoadmaps.filter(roadmap => roadmap.category === category.name);
            setAllRoadmaps(filteredRoadmaps);
        }
    };

    const guestUserHandler = (callbackId) => {
        const guestEmail = generateRandomEmail();
        const activeDomain = window.location.hostname.split('.')[1];

        const _payload = {
            email: guestEmail,
        }

        client.post(`/api/guest/token`, _payload).then(response => {
            const guestResp = response.data;

            if (guestResp.success) {
                const access_token = guestResp.data.access_token;
                setTokenExists(parseJwt(access_token));
                setPlCookie('pl.guestToken', access_token, 30, activeDomain);

                if (callbackId === 'comment-submit') {
                    submitComment(commentsInfo, false);
                } else if (callbackId === 'upvote-submit') {
                    createUpvotes(publicAuthModal.callbackParam, 'details');
                } else if (callbackId === 'comment-upvote-submit') {
                    comentsUpvote(isAnonymous.actions);
                }
            }

        }).catch(error => {
            console.log('guestResp error---', error);
        }).finally(() => {
            // setSaveCommentsLoader(false);
        });

        setIsAnonymous({
            email: guestEmail,
            name: 'Guest',
            value: true,
            actions: {},
        });
        authModalToggle();
        // write code to set auth token as guest.
    };

    const closeCommentsAlert = () => {
        setTimeout(() => {
            setCommentsAlert({ show: false, text: '' });
        }, 3000);
    }

    const submitComment = (commentsInfo, checkAuth) => {
        const userDetails = getUserToken();
        let userEmail = userDetails?.email;
        const _hostUrl = hostUrl.replace("www.", "");

        if (checkAuth && !isAnonymous.value) {
            if (!userEmail) {
                authModalToggle('signup', 'comment-submit');
                return;
            }
        }

        if (commentsInfo?.value?.length === 0) {
            return;
        }

        const payLoad = {
            company: companyID,
            comment: commentsInfo?.value,
            submittedBy: !isAnonymous.value ? userEmail : '',
            roamapId: roadmapInfo?._id['$oid'],
            is_guest_user: userDetails?.is_guest_user,
            url: _hostUrl
        };
        setSaveCommentsLoader({ show: true });
        client.post(`/feedback/public/comment`, payLoad).then(response => {
            const postResp = response.data;
            if (postResp.success) {
                setcommentsInfo({
                    value: '',
                    submittedBy: '',
                });
                getPostsDetails(match.params?.slug);
                setCommentsAlert({ show: true, text: 'Comment added', type: 'success' });
            } else {
                console.log('comments post success false---', postResp);
                setCommentsAlert({ show: true, text: postResp.msg, type: 'danger' });
            }
            closeCommentsAlert();
        }).catch(error => {
            console.log('comments post error---', error);
            setCommentsAlert({ show: true, text: 'An error occurred', type: 'danger' });
            closeCommentsAlert();
        }).finally(() => {
            setSaveCommentsLoader({ show: false });
        });
    };

    const comentsUpvote = (activity) => {
        const userEmail = getUserToken();
        if (!userEmail) {
            authModalToggle('signup', 'comment-upvote-submit');
            return;
        }
        const payload = {
            roadmapId: roadmapInfo._id['$oid'],
            activityId: activity.activity_id,
            email: userEmail?.email,
        };

        client.post(`/feedback/public/comment/upvote`, payload).then(response => {
            const roadmapResp = response.data;

            if (roadmapResp.success) {
                getPostsDetails(match.params?.slug);
            }
        }).catch(error => {
            console.log('upvote error---', error);
        });
    };

    const createUpvotes = (roadmap, param) => {
        const userDetails = getUserToken();
        const all_roadmaps = [...allRoadmaps];
        const _hostUrl = hostUrl.replace("www.", "");   // for custom url.

        if (!userDetails) {
            authModalToggle('signup', 'upvote-submit', roadmap);
            return;
        }
        const payload = {
            roadmapId: roadmap._id['$oid'],
            email: userDetails?.email,
            is_guest_user: userDetails?.is_guest_user,
            url: _hostUrl
        };

        client.post(`/feedback/public/upvotes`, payload).then(response => {
            const roadmapResp = response.data;
            if (roadmapResp.success) {
                const updated_roadmap = roadmapResp.data;

                if (param === 'details') {
                    getPostsDetails(match.params?.slug);
                } else {
                    // dont update upvotes if user has already upvoted.
                    const hasUserUpvoted = roadmap.upvoters?.some(upvoter => upvoter.email === userDetails?.email);
                    all_roadmaps.map((roadmapItem) => {
                        if ((roadmapItem._id['$oid'] === updated_roadmap._id['$oid']) && !hasUserUpvoted) {
                            roadmapItem.upvotes = roadmapItem.upvotes + 1;
                            roadmapItem.upvoters = updated_roadmap.upvoters;
                        }
                    });
                    setAllRoadmaps(all_roadmaps);
                }
            }
        }).catch(error => {
            console.log('public upvote error---', error);
        });
    };

    const getPostsDetails = (slug) => {
        const _slug = slug ? slug : match.params?.slug;
        const _hostUrl = hostUrl.replace("www.", "")
        const payLoad = {
            company: companyID,
            slug: _slug,
            activeSpaceName: activeSpace,
            url: _hostUrl
        };

        client.post(`/feedback/public/posts/details`, payLoad).then(response => {
            const postResp = response.data;
            if (postResp?.success) {
                setRoadmapInfo(postResp?.data);
            }
        }).catch(error => {
            console.error('Roadmap get details error---', error);
        });
    };

    const openLoginModal = () => {
        setPublicAuthModal({ show: true, type: 'login' })
    };

    const openOverviewModal = (_authType) => {
        setPayloadValid({ show: false, text: '' });
        setPublicAuthModal({ show: true, type: 'overview', overviewType: _authType, })
    };

    const openSignupModal = () => {
        setPublicAuthModal({ show: true, type: 'signup' })
    };

    const getPublicUserDetails = (_userToken) => {
        let _link = '';
        const identity = _userToken.sub;
        if (_userToken && !_userToken.is_guest_user) {
            const _params = {
                identity,
                is_guest: _userToken.is_guest_user,
            };
            setPlCookie('pl.authEmail', _userToken.sub, 30, activeDomain);
            client.get(`/feedback/public/user`, { params: _params }).then(response => {
                const _publicResp = response.data;
                _publicResp.data.workspaces.map((workspace) => {
                    if (workspace.isDefault) {
                        _link = `${window.location.protocol}//${workspace.name}${hostUrl.includes('localhost') ? '.localhost:3008/admin' : '.productlogz.com/admin'}`;
                    }
                });
                if (_publicResp.success) {
                    setPublicUserInfo({
                        ..._publicResp.data,
                        adminLink: _link,
                    });

                    posthog.identify(
                        _publicResp.data.email,
                        {
                            name: _publicResp.data.name,
                            email: _publicResp.data.email,
                        }
                    )
                }
            }).catch(error => {
                console.log('public get user error---', error);
            });
        }
    };

    const deleteCookie = (name, path, domain) => {
        if (getCookie(name)) {
            // console.log('delete cookie -->', name);
            document.cookie = name + "=" +
                ((path) ? ";path=" + path : "") +
                ((domain) ? ";domain=" + domain : "") +
                ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
        }
    }

    const publiclLogoutHandler = () => {
        const authType = getCookie('pl.authType');
        const authToken = getCookie('pl.authToken');

        if (tokenExists?.is_guest_user) {
            document.cookie = "pl.guestToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            setTokenExists(undefined);
            //window.location.reload();
        } else {
            const activeDomain = window.location.hostname.split('.')[1];
            client.get('/api/logout').then((resp) => {
                const authresp = resp.data;
                if (authresp.success) {
                    setTokenExists(undefined);
                    posthog.reset(); // reset posthog to unlink any future events made
                    if (authType === 'google') {
                        client.get('/api/token/revoke', { params: { token: authToken } });
                    }

                    if (activeDomain.includes('localhost')) {
                        document.cookie = "pl.authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                        document.cookie = "pl.refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

                        // deleteCookie("pl.authToken", "/", `${window.location.hostname}`);
                        // deleteCookie("pl.refreshToken", "/", `${window.location.hostname}`);
                    }
                    deleteCookie("pl.authToken", "/", `.${activeDomain}.com`);
                    deleteCookie("pl.refreshToken", "/", `.${activeDomain}.com`);
                }
            });
        }
    };

    // authenticate public user coming from sdk client classify method.
    const authenticateUser = (token) => {
        const url = `/api/user/authenticate`;
        client.post(url, { token }).then(response => {
            // console.log('response--->', response);
            const { data } = response;
            if (data.success) {
                const access_token = parseJwt(data.data.access_token);
                setTokenExists(access_token);
                setPlCookie('pl.authToken', data.data.access_token, 30, activeDomain);
                setPlCookie('pl.refreshToken', data.data.refresh_token, 30, activeDomain);
            }
        }).catch(error => {
            console.error('Authentication error:', error);
        });
    };

    const {
        name,
        logo,
        changelog_controls,
    } = companyInfo;

    useEffect(() => {
        const clientToken = new URLSearchParams(location.search).get('clientToken');
        if (clientToken) {
            // authenticate user from sdk client.
            authenticateUser(clientToken);
        }
    }, [location.search]);

    useEffect(() => {
        getRoadmapDetails(companyID);
        const utm_params = `utm_source=roadmap&utm_medium=powered&utm_campaign=${companyID}&company=${companyID}`;
        const _link = `https://productlogz.com?${utm_params}`;
        setPoweredBy(_link);
    }, [companyID]);

    useEffect(() => {
        if (tokenExists) {
            getPublicUserDetails(tokenExists);
        }
    }, [tokenExists]);

    useEffect(() => {
        const active_tab = match.params?.feature;
        if (active_tab) {
            setnavOption({
                parent: active_tab,
                slug: match.params?.slug,
            });
        }
    }, [match.params?.slug]);

    useEffect(() => {
        getToken(); // for auth token from social logins.
    }, []);

    // for public pages change page title.
    useEffect(() => {
        const _title = `${name} -${navOption.parent === 'roadmap' ? ' Roadmap' : ' Feature Requests'}`;
        document.title = _title;
    }, [name]);

    useEffect(() => {
        const _title = `${name} -${navOption.parent === 'roadmap' ? ' Roadmap' : ' Feature Requests'}`;
        document.title = _title;
    }, [navOption]);

    useEffect(() => {
        if (oldurl) {
            const company_id = window.location.pathname.split('/')[2];

            if (company_id === 'productlogz') {
                navigate(`//company.productlogz.com`);
            } else {
                navigate(`//${company_id}.productlogz.com`);
            }
        }
    }, [oldurl]);

    useEffect(() => {
        if (match.params?.slug && (match.params.feature === 'feature_requests' || match.params === 'roadmap')) {
            getPostsDetails();
        }
    }, [match.params?.slug]);

    return (
        <div className="public-roadmap">
            <AuthModal
                publicAuthModal={publicAuthModal}
                authModalToggle={authModalToggle}
                openLoginModal={openLoginModal}
                openSignupModal={openSignupModal}
                openOverviewModal={openOverviewModal}
                payloadValid={payloadValid}
                submitAuthManual={submitAuthManual}
                setauthPayload={setauthPayload}
                authPayload={authPayload}
                guestUserHandler={guestUserHandler}
                billingDetails={billingDetails}
            />
            <div className="public-navbar">
                <PublicNavbar
                    hostUrl={hostUrl}
                    roadmapLoader={roadmapLoader}
                    publicUserInfo={publicUserInfo}
                    tokenExists={tokenExists}
                    publiclLogoutHandler={publiclLogoutHandler}
                    openOverviewModal={openOverviewModal}
                    isOpen={isOpen}
                    toggle={toggle}
                    changeNavOption={changeNavOption}
                    navOption={navOption}
                    companyInfo={companyInfo}
                />
            </div>
            <div className="container container-sm container-public">
                {
                    !roadmapLoader ? (
                        <RoadmapContent
                            name={name}
                            navOption={navOption}
                            changelog_controls={changelog_controls}
                            allRoadmaps={allRoadmaps}
                            poweredBy={poweredBy}
                            openRoadmapDetailsPage={openRoadmapDetailsPage}
                            createUpvotes={createUpvotes}
                            saveCommentsLoader={saveCommentsLoader}
                            commentsAlert={commentsAlert}
                            roadmapInfo={roadmapInfo}
                            comentsUpvote={comentsUpvote}
                            setcommentsInfo={setcommentsInfo}
                            commentsInfo={commentsInfo}
                            getRoadmapDetails={getRoadmapDetails}
                            companyID={companyID}
                            roadmapToggle={roadmapToggle}
                            roadmapModal={roadmapModal}
                            authModalToggle={authModalToggle}
                            tokenExists={tokenExists}
                            getUserToken={getUserToken}
                            changeNavOption={changeNavOption}
                            submitComment={submitComment}
                            filterRoadmaps={filterRoadmaps}
                            companyInfo={companyInfo}
                        />
                    ) : (
                        <div style={{ textAlign: 'center' }}>
                            <Spinner>Loading...</Spinner>
                        </div>
                    )
                }
            </div>

        </div>
    );
};

export default WithBillingDetails(PublicWrapper);

